// FavouriteIcon
const FavouriteIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_143_141931)">
        <path
          d="M14.355 19.5C13.0097 20.4762 12.0299 21.0746 12.0299 21.0746C12.0299 21.0746 2 14.9253 2 9.97015C2 6.98503 3.85066 4 7.37315 4C10.597 4 12.0299 7.05323 12.0299 7.05323C12.0299 7.05323 13.2836 4 16.6865 4C20.0896 4 22 6.92534 22 9.97015C22 10.4215 21.9192 10.8815 21.7723 11.345"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="bevel"
        />
        <path
          d="M13.1953 14.3984L13.1953 16.3984L16.3382 16.3984L17.3382 15.3984L16.3382 14.3984L13.1953 14.3984Z"
          fill="currentColor"
        />
        <path
          d="M18.8438 10.7539L16.8438 10.7539L16.8437 13.8968L17.8437 14.8968L18.8437 13.8968L18.8438 10.7539Z"
          fill="currentColor"
        />
        <path
          d="M22.4844 14.3984L22.4844 16.3984L19.3415 16.3984L18.3415 15.3984L19.3415 14.3984L22.4844 14.3984Z"
          fill="currentColor"
        />
        <path
          d="M18.8359 20.043L16.8359 20.043L16.8359 16.9001L17.8359 15.9001L18.8359 16.9001L18.8359 20.043Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_143_141931">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FavouriteIcon
